import '../styles/Projects.css'; 

import ImagePanel from '../components/ImagePanel';

import image1 from '../assets/DSCN2582.JPG';
import image2 from '../assets/DSCN2622.JPG';
import image3 from '../assets/1737039460712.jpg';
import image4 from '../assets/1737039567711.jpg';
import image5 from '../assets/1737039248696.jpg';
import image6 from '../assets/1737039336172.jpg';
// import image7 from '../assets/1737039630253.jpg';
import image8 from '../assets/1737039762974.jpg';
import image9 from '../assets/1737039920384.jpg';
import image10 from '../assets/1737039965057.jpg';
import image11 from '../assets/1737040010982.jpg';
import image12 from '../assets/1737040284617.jpg';
import image13 from '../assets/1737040302959.jpg';
import image14 from '../assets/1737040465251.jpg';
// import image15 from '../assets/1737041636371.jpg';
import image16 from '../assets/1737041735802.jpg';

const imagesKarachi = [
  image1, image2, image3, image4, image5, image6, image8, image9, image10, image11, image12,
  image13, image14, image16
];

function Projects() {
  return (
    <div className="projects flex flex-col m-40">
      <h1 className="header-block mb-12">Karachi, Pakistan</h1>

      <div className="images flex flex-col lg:flex-row items-center gap-12">
        {/* Slideshow */}
        <div className="flex-1">
          <ImagePanel images={imagesKarachi} />
        </div>

        {/* Project Description */}
        <div className="flex-1 text-left">
          <h2 className="text-2xl font-semibold mb-4">School Renovation Project</h2>
          <p className="text-md font-medium tan mb-4">Progress: Under Construction</p>
          <p className="project-text text-gray-700 leading-relaxed">
            In 2024, we began a new school construction initiative for a rural school in Karachi, Pakistan, to improve access to safe, quality education and provide a vocational training center to teach practical skills.
            <br /><br />
            The project includes a groundbreaking construction effort to accommodate approximately 100 students, with multiple classrooms for both girls and boys in primary education. It will also feature a library, a computer lab, and new desks and supplies for students.
            <br /><br />
            Construction is currently ongoing, with the goal of completing essential infrastructure and upgrades by the end of 2025, InshaAllah. We continue working closely with local contractors and community members to ensure long-term impact, sustainability, and growth for underserved neighborhoods.
          </p>
        </div>
      </div>
    </div>
  );
}


export default Projects;
